import React from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

const confirmDelete = (deleteTemplatePage) => {
  swal
    .fire({
      title: 'Delete Template Page?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
      animation: 'slide-from-top',
    })
    .then(({ value }) => {
      if (value){
        deleteTemplatePage()
      }
    })
}

const TemplatePage = (props) => {
  const {
    callbacks: { deleteTemplatePage },
    templatePage: { height, title, width },
  } = props

  return (
    <DashboardModuleListItem title={title}>
      <DashboardModuleListItem.TertiaryText>
        {`${width} x ${height}mm`}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(deleteTemplatePage)}
          type="delete"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

TemplatePage.propTypes = {
  callbacks: PropTypes.shape({
    deleteTemplatePage: PropTypes.func.isRequired,
  }).isRequired,
  templatePage: PropTypes.object.isRequired,
}

export default TemplatePage
